import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import TextInput from '../../generic/fields/TextInput';
import { validRadio, validString } from '../../../helpers/check-required-fields';
import icon from '../../../images/icon-event-place.svg'

class Where extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <Row className="twoCol">
        <img src={icon} width="35" height="48"/>
      	<div style={{marginLeft: '20px', flex: 1}}>
          <h2>Place</h2>
          {['in_person', 'online_in_person'].indexOf(userEvent.event_type) > -1 && <React.Fragment>
            <p>
              {userEvent.address_description && (<React.Fragment>{userEvent.address_description}<br/></React.Fragment>)}
              {userEvent.address_1}<br/>
              {userEvent.city}, {userEvent.province}
            </p>
          </React.Fragment>}
          {['online', 'online_in_person'].indexOf(userEvent.event_type) > -1 && <React.Fragment>
              {validString(userEvent.online_url) ? (
                <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                  <strong>Meeting link: </strong>
                  <a target="_blank" style={{marginLeft: 0}} href={userEvent.online_url}>{userEvent.online_url.replace(/((https?):\/\/)/, '')}</a>
                </p>
              ): (
                <p>
                  {userEvent.event_type === 'online' && <strong>This gathering will be online</strong>}
                  {userEvent.event_type === 'online_in_person' && <strong>This gathering will also be available online</strong>}
                </p>
              )}
          </React.Fragment>}
          {userEvent.extra_directions && (
            <p>
              <strong>Extra Directions and Notes: </strong>
              <div>{userEvent.extra_directions}</div>
            </p>
          )}
          {!this.props.public && (
            <React.Fragment>
              {validRadio(userEvent.public_access, false) ? (
                <p><strong>Your gathering is private</strong></p>
              ) : (
                <p><strong>Your gathering is public</strong></p>
              )}
            </React.Fragment>
          )}
        </div>
      </Row>
    )
  }
}

export default Where
